module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "siteInput"
  }, [_vm._v("\n  " + _vm._s(_vm.nameFn) + "\n  "), (_vm.name) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "siteInputShow",
    attrs: {
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "click": _vm.queryShowFn,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }) : _c('span', {
    staticClass: "siteInputShow placeholder",
    on: {
      "click": _vm.queryShowFn
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]), _vm._v(" "), _c('div', {
    staticClass: "result",
    class: _vm.resultState ? 'showResult' : '',
    on: {
      "touchstart": _vm.resultFn
    }
  }, [_c('div', {
    staticClass: "Title"
  }, [_c('div', {
    staticClass: "selectCity",
    class: _vm.acCityState ? 'selectCityShow' : '',
    on: {
      "click": _vm.cityAcFn
    }
  }, [_c('span', {
    staticClass: "city"
  }, [_vm._v(_vm._s(_vm.cityShow))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "queryInput",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, function($event) {
        return _vm.mapFn(_vm.query, 'input')
      }],
      "click": function($event) {
        $event.stopPropagation();
        return _vm.mapFn(_vm.query)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "closeBut",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.moduleFn.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.acCityState) ? _c('div', {
    staticClass: "shortcut clear"
  }, _vm._l((_vm.shortcutData), function(item, index) {
    return _c('div', {
      staticClass: "shortcut-row",
      class: {
        'shortcut-row-ac': _vm.shortcutAc === item
      },
      on: {
        "click": function($event) {
          return _vm.shortcutClickFn(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.acCityState) ? _c('div', {
    ref: "cityMod",
    staticClass: "cityMod"
  }, [_c('div', {
    staticClass: "hotCity"
  }, [_c('div', {
    staticClass: "cityRow"
  }, [_c('div', {
    staticClass: "title clear"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "Right",
    on: {
      "click": function($event) {
        return _vm.acCityFn(_vm.positioning.city)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dingwei"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.positioning.name !== '获取定位失败' && _vm.positioning.city ? _vm.positioning.city : '定位失败'))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.hotCity), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.acCityFn(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item) + "\n              ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "cityList"
  }, [_vm._v("\n        " + _vm._s(_vm.getCityFn) + "\n        "), _vm._l((_vm.getCity), function(item, index) {
    return _c('div', {
      ref: "cityRow",
      refInFor: true,
      staticClass: "cityRow"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n            " + _vm._s(item.letter) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('ul', _vm._l((item.content), function(key, index) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.acCityFn(key.name)
          }
        }
      }, [_vm._v("\n                " + _vm._s(key.name) + "\n              ")])
    }), 0)])])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.acCityState) ? _c('div', {
    staticClass: "replaceCityList"
  }, [_c('ul', {
    on: {
      "touchmove": _vm.replaceCityListFn
    }
  }, _vm._l((_vm.getCity), function(item, num, index) {
    return _c('li', {
      ref: "replaceCityItem",
      refInFor: true,
      class: _vm.acCityIndex === index ? 'ac' : '',
      on: {
        "click": function($event) {
          return _vm.vibrationFn(index)
        }
      }
    }, [_c('span', {}, [_vm._v("\n            " + _vm._s(item.letter) + "\n            ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "searchMod"
  }, [(_vm.query === '' && _vm.addressrecord && _vm.addressrecord.length > 0) ? _c('div', {
    staticClass: "resultCont addressRecord"
  }, [_c('ul', _vm._l((_vm.addressrecord), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.actionFn(item.address)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(item.address.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.address.detailedAddress))])])
  }), 0)]) : _vm._e(), _vm._v(" "), ((_vm.query !== '' || _vm.shortcutAc !== '') && _vm.result.length > 0) ? _c('div', {
    staticClass: "resultCont"
  }, [_c('ul', _vm._l((_vm.result), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.actionFn(item)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.detailedAddress))])])
  }), 0)]) : (_vm.query !== '' && _vm.result.length <= 0) ? _c('div', {
    staticClass: "without"
  }, [_vm._v("\n        没有信息\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "module",
    class: _vm.resultState ? 'moduleShow' : '',
    on: {
      "click": _vm.moduleFn
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "iconfont icon-jiantou"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Left"
  }, [_c('i', {
    staticClass: "iconfont icon-xing"
  }), _vm._v(" "), _c('span', [_vm._v("热门城市")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01bf45de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/siteInput/src/siteInput.vue
// module id = 498
// module chunks = 0